import { generateShortSlug } from '../utils/helpers';
import { loadCompanySeedContext } from './loadCompanySeedContext';
import { buildDemoAppointmentPayloads } from './buildDemoAppointmentPayloads';
import {
  demoAppointmentIdsStorageKey,
  DEMO_APPOINTMENT_SOURCE,
} from './constants';
import { newRecordId } from '../api/companyRecords';
import { upsertAppointment } from '../api/appointments';

export async function seedDemoAppointments({
  companyId,
  ownerId,
  anchorDate = new Date(),
  isSpecialAdmin = false,
  useCompanyData = true,
}) {
  if (!isSpecialAdmin) {
    throw new Error('Demo appointments are available to special admins only.');
  }

  const { staff, services, usingCompanyData, companyHours } = await loadCompanySeedContext({
    companyId,
    ownerId,
    useCompanyData,
  });

  const demoBatchId = `demo-${Date.now()}`;
  const payloads = buildDemoAppointmentPayloads({
    companyId,
    anchorDate,
    staff,
    services,
    demoBatchId,
    companyHours,
  });

  const createdIds = [];
  for (const payload of payloads) {
    const id = newRecordId();
    createdIds.push(id);
    await upsertAppointment({
      companyId,
      id,
      appointment: {
        ...payload,
        id,
        companyId,
        source: DEMO_APPOINTMENT_SOURCE,
        demoBatchId,
        shortSlug: generateShortSlug(),
        dateTime: payload.dateTime instanceof Date ? payload.dateTime.toISOString() : payload.dateTime,
        endTime: payload.endTime instanceof Date ? payload.endTime.toISOString() : payload.endTime,
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString(),
      },
    });
  }

  const storageKey = demoAppointmentIdsStorageKey(companyId);
  const existingRaw = window.localStorage.getItem(storageKey);
  const existingIds = existingRaw ? JSON.parse(existingRaw) : [];
  window.localStorage.setItem(
    storageKey,
    JSON.stringify([...existingIds, ...createdIds])
  );

  const todayCount = payloads.filter((p) => {
    const anchor = new Date(anchorDate);
    anchor.setHours(0, 0, 0, 0);
    const slotDay = new Date(p.dateTime);
    slotDay.setHours(0, 0, 0, 0);
    return slotDay.getTime() === anchor.getTime();
  }).length;

  return {
    count: createdIds.length,
    todayCount,
    demoBatchId,
    usingCompanyData,
    source: DEMO_APPOINTMENT_SOURCE,
  };
}
